import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCopy07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.161 7h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 19.82 1 19.365 1 18.838v-7.677c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 7 4.635 7 5.161 7ZM13 2a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1Zm-1.5-.01a1 1 0 0 1-.986 1.013c-.694.01-.875.058-.968.106a1 1 0 0 0-.437.437c-.048.093-.097.274-.106.968a1 1 0 0 1-2-.028c.009-.656.038-1.286.324-1.848a3 3 0 0 1 1.311-1.311c.562-.286 1.192-.315 1.848-.324a1 1 0 0 1 1.014.986Zm7 0a1 1 0 0 1 1.014-.987c.656.009 1.286.038 1.848.324a3 3 0 0 1 1.311 1.311c.286.562.315 1.192.324 1.848a1 1 0 1 1-2 .028c-.01-.694-.058-.875-.106-.968a1 1 0 0 0-.437-.437c-.093-.048-.274-.097-.968-.106a1 1 0 0 1-.986-1.014ZM22 7a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm.01 5.5a1 1 0 0 1 .987 1.014c-.009.656-.038 1.286-.324 1.848a3 3 0 0 1-1.311 1.311c-.562.286-1.192.315-1.848.324a1 1 0 1 1-.027-2c.693-.01.874-.058.967-.106a1 1 0 0 0 .437-.437c.048-.093.097-.274.106-.968a1 1 0 0 1 1.014-.986Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgCopy07.displayName = 'Copy07';
export default SvgCopy07;
